const { isEmpty } = require('lodash');
const { isMultibyte, isEmail, } = require('validator');

const { entries } = Object;

module.exports = {
  fields: {
    email: {
      type: 'string',
      label: 'メールアドレス',
      validations: {
        required: v => !isEmpty(v),
        format: v => !v || isEmail(v),
        notMultibyte: v => !v || !isMultibyte(v),
      },
    },
    tenantName: {
      type: 'string',
      label: '会社名/個人事業名',
      validations: {
        required: v => !isEmpty(v),
      },
    },
    displayName: {
      type: 'string',
      label: 'ユーザー名',
    },
    phone: {
      type: 'string',
      label: '電話番号',
      validations: {
        format: v => !v || v.match(/^(0{1}\d{9,10})$/),
      },
      placeholder: '08012345678 （ハイフンなし）'
    },
    password: {
      type: 'password',
      label: 'パスワード',
      validations: {
        required: v => !isEmpty(v),
        minLength: v => (v || '').length >= 6,
      },
      placeholder: '6文字以上'
    },
    currentPassword: {
      type: 'password',
      label: '現在のパスワード',
      validations: {
        required: v => !isEmpty(v),
      },
    },
    passwordConfirmation: {
      type: 'password',
      label: 'パスワード確認',
      validations: {
        required: (v, { password }) => !isEmpty(v),
        samePassword: (v, { password }) => v === password,
      },
    },
  },
  fieldsToSignIn: ({ isForStaff = false, } = {}) => {
    return {
      [isForStaff ? 'staffId' : 'email']: {
        type: 'string',
        label: isForStaff ? 'スタッフID' : 'メールアドレス',
        validations: {
          required: v => !isEmpty(v),
          ...(
            !isForStaff && {
              format: v => !v || isEmail(v),
            }
          ),
        },
      },
      password: {
        type: 'password',
        label: 'パスワード',
        validations: {
          required: v => !isEmpty(v),
        },
      }
    };
  },
  staffFields: {
    staffId: {
      type: 'string',
      label: 'スタッフID',
      validations: {
        required: v => !isEmpty(v),
      },
    },
    displayName: {
      type: 'string',
      label: 'ユーザー名',
      validations: {
        required: v => !isEmpty(v),
      },
    },
    password: {
      type: 'password',
      label: 'パスワード',
      validations: {
        required: v => !isEmpty(v),
        minLength: v => isEmpty(v) || v.length >= 6,
      },
      placeholder: '6文字以上'
    },
    enablesShippingWithQuantity: {
      type: 'boolean',
      label: '数量入力出荷を有効にする',
      initialValue: false,
    },
  },
};
